module.exports = __webpack_public_path__ + "static/img/banner_bg1.c41d9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner_bg1.png
// module id = dDUI
// module chunks = 9